import { jsx as n } from "react/jsx-runtime";
import t from "./chunk511.js";
import i from "clsx";
import { Button as p } from "./chunk2.js";
const l = (o) => {
  const { children: r, className: m, ...s } = o;
  return /* @__PURE__ */ n(p, { className: i(t.button, t.primaryButton, m), ...s, children: r });
};
export {
  l as PrimaryButton
};
